<template>
  <div>
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      APP版本<span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>
    </div>
    <form class="class_add_con w622 col_2_1 " data-vv-scope="form" style="width: 944px;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="page_edit_table">
        <tr class="tita">
          <td colspan="2" align="left" class="left_td" style="text-align:left;">APP版本基本信息</td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">类型：<span>*</span></td>
          <td><select v-model="form.type" @change="setCurrentCode">
            <option value="1">Android</option>
            <option value="2">IOS</option>
          </select></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">版本：<span>*</span></td>
          <td style="position: relative;">
            <input name="code" type="text" disabled class="put_txt w50" v-validate="'required'" v-model="form.code" />
            <span style="display: inline-block; position: absolute; left: 100px;" class="error_msg">{{errors.first('form.code')}}</span>
          </td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">版本号：<span>*</span></td>
          <td style="position: relative;">
            <input type="text" name="version1" v-model="formVersionInput1" v-validate="'required'" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" class="put_txt w50">
            <span style="vertical-align: bottom; color: #a9a9a9;">.</span>
            <input type="text" name="version2" v-model="formVersionInput2" v-validate="'required'" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" class="put_txt w50">
            <span style="vertical-align: bottom; color: #a9a9a9;">.</span>
            <input type="text" name="version3" v-model="formVersionInput3" v-validate="'required'" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" class="put_txt w50">
            <!--span style="display: inline-block; position: absolute; left: 240px;" class="error_msg">{{errors.first('form.version')}}</span-->
            <span v-if="form.version">上一版本号: {{form.version}}</span>
          </td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">包名：</td>
          <td><input name="packageName" type="text" class="put_txt w200" v-model="form.packageName" /></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">下载地址：</td>
          <td><input name="url" type="text" class="put_txt w200" v-model="form.url" /></td>
        </tr>
        <tr>
          <td align="center" class="t_left3" >备注：</td>
          <td><textarea name="remarks" cols="" rows="" v-model="form.remarks" class="text_area"></textarea></td>
        </tr>
        <tr>
          <td class="t_left2">&nbsp;</td>
          <td align="left"  class="t_left2">
            <input name="" type="button" class="put_btn" value="确认提交" @click="validateForm('form')" />　
            <!--input name="" class="put_btn" type="button" value="重填" /-->
          </td>
        </tr>
      </table>
    </form>
    <div class="clear"></div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  export default {
    components: {},
    data () {
      return {
        form: {
          code: '',
          type: '1'
        },
        formVersionInput1: '',
        formVersionInput2: '',
        formVersionInput3: '',
        flag: false,
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
        this.setCurrentCode()
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      }
    },
    methods: {
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      setCurrentCode () {
        this.getModel(this.form.type).then((r) => {
          if (r) {
            this.form.code = '' + (Number(r[0].code) + 1)
            this.form.version = r[0].version
          } else {
            this.form.code = '1'
            this.form.version = ''
          }
        })
      },
      combineFormVersion (i1,i2,i3) {
        return i1 + '.' + i2 + '.' + i3
      },
      validateForm (scope) {
        var bus = this
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            bus.form.version = bus.combineFormVersion(bus.formVersionInput1, bus.formVersionInput2, bus.formVersionInput3)
            bus.confirmBox({
              yes: function () {
               api.post(config.bylApiPath, '/appVersion/edit', bus.form, function (r) { // 正常
                  if (bus.isEdit) { // 编辑
                    bus.popup('保存成功')
                  } else {
                    bus.popup('新建成功')
                  }
                  bus.$router.push(bus.prefix + '/org/appmgtList')
                })
              }
            })
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      to (path) {
        this.$router.push(path)
      },
      getModel (type) {
        var that = this
        return new Promise(function (resolve, reject) {
          api.post(config.bylApiPath, '/appVersion/findList', {type:type}, function (r) { // 正常
            resolve(r.data)
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/byl/org/appmgt/model.vue